(() => {
  if (customElements.get('cro-cart-complements')) return;
  let pairingPromise;
  let adding = false;
  const trace = (event, data = {}) => {
    window.valfreCroPreviewEvents = [...(window.valfreCroPreviewEvents || []), {event, ...data}].slice(-30);
  };
  class CroCartComplements extends HTMLElement {
    connectedCallback() { this.controller = new AbortController(); this.render(); }
    disconnectedCallback() { this.controller.abort(); this.observer?.disconnect(); }
    async read(url) {
      const res = await fetch(url, {signal:this.controller.signal, credentials:'same-origin'});
      if (!res.ok) throw new Error('Read failed');
      return res.json();
    }
    async render() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        pairingPromise ||= fetch(this.dataset.pairings).then(r=>{if(!r.ok)throw new Error("Pairings unavailable");return r.json();}).catch(error => {pairingPromise = null;throw error;});
        const [cart, model] = await Promise.all([this.read(root + 'cart.js'), pairingPromise]);
        if (!this.isConnected || cart.currency !== 'USD' || !cart.items.length) return;
        const present = new Set(cart.items.map(item => item.product_id));
        const paired = [...new Set(cart.items.flatMap(item => model.pairs[item.handle] || []))].slice(0,6);
        const handles = [...new Set([...paired, ...(model.fallback || [])])];
        const products = await Promise.all(handles.map(handle => this.read(root+'products/'+encodeURIComponent(handle)+'.js').catch(() => null)));
        const choices = products.filter(product => product && product.available && !present.has(product.id) && product.variants.length === 1 && product.variants[0].available && !product.requires_selling_plan && !(product.selling_plan_groups?.length)).slice(0,2);
        if (!this.isConnected || !choices.length) return;
        this.replaceChildren();
        const heading = document.createElement('h3');heading.className='cro-addon-heading';heading.textContent=this.dataset.heading;this.append(heading);
        this.status=document.createElement('p');this.status.className='cro-addon-status';this.status.setAttribute('role','status');
        for (const product of choices) {
          const row=document.createElement('div');row.className='cro-addon-row';
          const image=document.createElement('img');image.src=product.featured_image;image.alt='';image.loading='lazy';image.width=54;image.height=64;
          const info=document.createElement('div');info.className='cro-addon-info';
          const link=document.createElement('a');link.href=root+'products/'+encodeURIComponent(product.handle);link.textContent=product.title;
          const price=document.createElement('span');price.className='cro-addon-price';price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:cart.currency}).format(product.variants[0].price/100);
          const button=document.createElement('button');button.type='button';button.textContent=this.dataset.add;button.setAttribute('aria-label',this.dataset.add+' '+product.title);
          button.addEventListener('click',()=>this.add(product,button,root));info.append(link,price);row.append(image,info,button);this.append(row);
        }
        this.append(this.status);this.hidden=false;
        this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){trace('preview_exposure',{products:choices.map(p=>p.id),model:model.version});this.observer.disconnect();}},{threshold:.5});this.observer.observe(this);
      } catch { this.hidden=true; }
    }
    async add(product,button,root) {
      if (adding) return;
      adding=true;this.querySelectorAll('button').forEach(b=>b.disabled=true);button.textContent=this.dataset.adding;
      trace('preview_add_requested',{product:product.id});
      try {
        const drawer=document.querySelector('cart-drawer');
        const sections=drawer?.getSectionsToRender().map(s=>s.id)||['cart-drawer','cart-icon-bubble'];
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:product.variants[0].id,quantity:1}],sections,sections_url:location.pathname})});
        const result=await res.json();
        if(!res.ok||result.status)throw new Error('Cart rejected');
        trace('preview_add_confirmed',{product:product.id});
        if(!drawer||!result.sections||sections.some(id=>!result.sections[id])){location.assign(root+'cart');return;}
        drawer.renderContents({...result,...result.items?.[0],sections:result.sections});
        setTimeout(()=>{document.querySelector('editorial-cart-feedback')?.hide();drawer.open();},180);
      } catch {
        trace('preview_add_unconfirmed',{product:product.id});
        this.status.textContent=this.dataset.error+' ';
        const link=document.createElement('a');link.href=root+'cart';link.textContent=this.dataset.view;this.status.append(link);
      } finally { adding=false; }
    }
  }
  customElements.define('cro-cart-complements',CroCartComplements);
})();
